// The signed-in investor's Bearer header, read from localStorage at request
// time. AuthContext's `token` is captured once when the app loads and is not
// updated by LOGIN or by client.js refreshing the token, so it is null right
// after a first login and stale after a refresh.
export const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("access")}`,
});
